// extracted by mini-css-extract-plugin
export default {"container":"ReactionThreadFull-module__container--qgs5D","expanded":"ReactionThreadFull-module__expanded--i1D16","reactions":"ReactionThreadFull-module__reactions--hAz3B"};